import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'

const app = createApp(App)

app.use(router)
app.use(store)

// Global error handler
app.config.errorHandler = (err, vm, info) => {
  console.error('Global error:', err, info)
  store.commit('setError', err.message)
}

// Mount the app
app.mount('#app')

// Initialize auth state after mounting
store.dispatch('initializeAuth')